import {http} from "services";
import axios from "axios";

// TODO Implement api requests
export const List = async ({params}) => http.request.post('https://api.birdarcha.uz/v1/admin/register_requirements/search-external', {
    // type: "GENERAL",
    // oked_id: "",
    search: params.filter,
}, {
    params: {
        size: params.perPage,
        page: params.page,
        lang: "uz",
    },
    headers: {
        "X-Api-Key": '9176b538-f59a-414c-a3b9-49a05e984fd9'
    }
})

export const DownloadExcel = async ({params}) => http.request.post('/v1/gov-service/open/download/excel', {
        per_page: params.perPage,
        page: params.page,
        sort: params.sort,
        search: params.filter,
    },
    {
        responseType: 'blob'
    }
)

export const Single = async ({id}) => http.request.get(`/v1/gov-service/open/${id}`)
